import { SingleValueRxEmitter } from '@ocodelib/ex-util';

/**
 * 사용자 프로필 다이얼로그 표시
 */
export const UserProfileDialogOpenEvent = new SingleValueRxEmitter(0);
